var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiIcAlertError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 22H7.8L2 16.2V7.8L7.8 2H16.2L22 7.8V16.2L16.2 22ZM8.2 21H15.8L21 15.8V8.2L15.8 3H8.2L3 8.2V15.8L8.2 21ZM12.9 16.1C12.9 16.6 12.5 17 12 17C11.5 17 11.1 16.6 11.1 16.1C11.1 15.6 11.5 15.2 12 15.2C12.5 15.2 12.9 15.6 12.9 16.1ZM11.4 10.1V7H12.7V10.1L12.4 13.9H11.8C11.7 13.9 11.4 10.1 11.4 10.1Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIcAlertError);
export default __webpack_public_path__ + "static/media/ui-ic-alert-error.4e13b64cc5616a02bea00d44fcd9cec3.svg";
export { ForwardRef as ReactComponent };